import { analyticsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { getUuid } from 'store/auth/selectors';

import { normalizeGraphicsData } from './utils';

export const ANALYTICS_DASHBOARDS_ACTION_TYPE = createNamedActions('analytics-dashboards-', {
  GET_COMPANY_DASHBOARDS: 'GET_COMPANY_DASHBOARDS',
  GET_USER_DASHBOARDS: 'GET_USER_DASHBOARDS',
  GET_DASHBOARD_EMBED_LINK: 'GET_DASHBOARD_EMBED_LINK',
  SET_SELECTED_DASHBOARDS_BY_ROLE: 'SET_SELECTED_DASHBOARDS_BY_ROLE',
  RESET_DASHBOARDS_STATE: 'RESET_DASHBOARDS_STATE',
});

export const getCompanyDashboardsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await analyticsApi.getDashboards();

  return dispatch({
    type: ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_COMPANY_DASHBOARDS,
    payload: normalizeGraphicsData(data),
  });
});

export const getUserDashboardsAction = catchAsyncActionError(() => async (dispatch, getState) => {
  const userId = getUuid(getState());

  const { data } = await analyticsApi.getDashboardsByUserId(userId);

  return dispatch({
    type: ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_USER_DASHBOARDS,
    payload: normalizeGraphicsData(data),
  });
});

export const getDashboardEmbedLinkAction = catchAsyncActionError(dashboardId => async dispatch => {
  const { data } = await analyticsApi.getDashboardEmbedLinkByDashboardId(dashboardId);

  return dispatch({
    type: ANALYTICS_DASHBOARDS_ACTION_TYPE.GET_DASHBOARD_EMBED_LINK,
    payload: data,
  });
});

export const setSelectedDashboardsByRoleAction = catchAsyncActionError(
  ({ dataToSave, dataToStore }) =>
    async dispatch => {
      await analyticsApi.setSelectedDashboards(dataToSave);

      return dispatch({
        type: ANALYTICS_DASHBOARDS_ACTION_TYPE.SET_SELECTED_DASHBOARDS_BY_ROLE,
        payload: dataToStore,
      });
    },
);

export const resetDashboardsStateAction = () => ({
  type: ANALYTICS_DASHBOARDS_ACTION_TYPE.RESET_DASHBOARDS_STATE,
});
